import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// d.ts
import { DCRecord, IDataController } from "@/@types/lib/dataController";

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";
import DialogContext from "@/ui/DialogContext/DialogContext";
import ProjectDialog from "./ProjectDialog";

import model from "@/models/project";
import dataController from "@/lib/dataController";
import { DialogContextType } from "@/@types/ui/DialogContext";
import { useNavigate } from "react-router";
import { SnackbarContextType } from "@/@types/ui/SnackbarContext";
import SnackbarContext from "@/ui/SnackbarContext/SnackbarContext";

function ProjectsTable() {
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const snackbarContext = useContext(SnackbarContext) as SnackbarContextType;
  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(model);
  const navigate = useNavigate();

  useEffect(() => {
    refreshRecords();
  }, []);

  const handleAdd = () => {
    dialogContext.showDialog(ProjectDialog, {
      dc: dc,
      mode: "insert",
      form: "insert",
      onClose: handleDialogClose,
    });
  };

  const handleDialogClose = (result: {
    dataChanged: boolean;
    action: string;
  }) => {
    if (result.dataChanged) {
      refreshRecords();
    }
    dialogContext.hideDialog();
  };

  const refreshRecords = () => {
    dc.GetData().then((resp) => {
      if (resp.success) {
        setRecords(resp.data as Array<DCRecord>);
      }
    });
  };

  const handleDelete = () => {
    const msg = "messages.record_delete_success";
    snackbarContext.showNotification(msg, "success");
    refreshRecords();
  };

  return (
    <ModelTable
      title={t("titles.projects")}
      records={records}
      dc={dc}
      allowSelection={"none"}
      allowFilter={true}
      allowExport={true}
      allowEdit={true}
      allowDelete={true}
      onDeleted={handleDelete}
      onEdit={(recordId: number) => navigate("/projects/" + recordId)}
      allowAdd={true}
      addLabel={t("buttons.new_m")}
      handleAdd={handleAdd}
      onRowAction={() => {}}
      allowRowAction={() => {
        return true;
      }}
    />
  );
}

export default ProjectsTable;
